<div class="container mt-4 mb-5">
  <div class="row">
    <div class="col-6">
      <h4 i18n>Pagamento</h4>
      <p class="pl-1 mb-4" i18n>Verifique os dados para finalizar!</p>
    </div>
    <div *ngIf="pedido && pedido.itens.length" class="col-6 text-right">
      <div class="btn-group btn-group-toggle checkout-visualizacao-grupo-btn" data-toggle="buttons">
        <label (click)="toRoute(1)" [class.active]="modo == 1" class="btn btn-primary">
          <input type="radio" name="options" id="option1" autocomplete="off" /><i class="icofont-list"></i>
        </label>
        <label (click)="toRoute(2)" [class.active]="modo == 2" class="btn btn-primary">
          <input type="radio" name="options" id="option3" autocomplete="off" /><i class="icofont-listing-number"></i>
        </label>
      </div>
    </div>
  </div>
  <div *ngIf="!pedido" class="col-lg-6 offset-lg-3 text-center">
    <h5 i18n>Selecione um Pedido!</h5>
    <img src="assets/empty.png" class="img-fluid" />
  </div>
  <div *ngIf="pedido" class="col-lg-12">
    <div class="row mt-2 mb-2">
      <div class="col-sm-1">
        <label i18n>Código</label><br />
        <div *ngFor="let c of filtrados">
          {{ c.id }}<br />
        </div>
      </div>
      <div class="col-sm-5">
        <app-selecao-clientes 
          [isReadOnly]="true"
          [showTodos]="true" 
          [SITE]="SITE" 
          [pedido]="pedido"
          [pedidoClienteSelected]="pedidoClienteSelected"
          [changePedidoClienteSelectedTodos]="changePedidoClienteSelectedTodos.bind(this)"
          [changePedidoClienteSelected]="changePedidoClienteSelected.bind(this)"
          [getLinkAprovaCliente]="getLinkAprovaCliente.bind(this)">
          >
        </app-selecao-clientes>
        <!-- <label><input type="checkbox" value="true" [(ngModel)]="pedidoClienteSelected.todos"
            (change)="changePedidoClienteSelectedTodos()" />
          {{ SITE.labelCliente }}</label><br />
        <div *ngFor="let pc of pedido.clientes">
          <label style="font-size: inherit">
            <input type="checkbox" value="true" [(ngModel)]="pedidoClienteSelected[pc.cliente.id]"
              (change)="changePedidoClienteSelected()" />
            {{ pc.cliente[SITE.identificacaoCliente] }} -
            {{ pc.cliente.nome }}
          </label>
          <a *ngIf="pedido.tipo.aprovacaoCliente" (click)="getLinkAprovaCliente(pc.id)" style="cursor: pointer">
            <span *ngIf="pc.aprovado; else elseBlockAprvCli" style="color: green">&nbsp; <b><u>APROVADO</u></b></span>
            <ng-template #elseBlockAprvCli><span style="color: orange">&nbsp; <b><u>AGUARDANDO</u></b></span>
            </ng-template>
          </a>
        </div> -->
      </div>
      <div class="col-sm-6 label-filial-checkout">
        <label>{{ SITE.labelFilial }}</label><br />
        <div class="form-group">
          <div class="row">
            <div class="col-10 p-0">
              <div>
                {{ filialSelecionada?.codigo }} - {{ filialSelecionada?.descricao }}

              </div>
            </div>
            <!-- <div *ngIf="filiais.length > 1 && !pedido.salvoCheckout" class="col-2 pl-1">
              <button (click)="savePedidoFilial()" class="btn btn-primary btn-sm">
                <i class="icofont-ui-edit"></i>
              </button>
            </div> -->
          </div>
        </div>
      </div>
      <!-- <div class="col-sm-3 tabela-checkout">
        <label i18n>Tabela</label><br />
        {{ pedido.tabela.codigo }} - {{ pedido.tabela.descricao }}
      </div> -->
    </div>

    <div class="row mt-2 mb-2">
      <div class="col-2" *ngIf="limiteDisponivel && limiteDisponivel !== null">
        <label i18n>Limite disponível: </label>
        <span i18n style="color: green; font-weight: bold;">
          R$ {{ limiteDisponivel | currency : "BRL" : "" }}
        </span>
      </div>
      <div [class]="limiteDisponivel && limiteDisponivel !== null ? 'col-4' : 'col-6'"></div>
      <div class="col-6 tipo-pedido-checkout">
        <label>{{ SITE.labelPedidoTipo }}</label><br />
        <div class="form-group">
          <div class="row align-items-center">
            <div class="col-10 p-0">
               <div>
                {{ tipoPedidoSelecionado?.tipo}} - {{ tipoPedidoSelecionado?.descricao }}

              </div>
            </div>
            <!-- <div *ngIf="pedidoTiposUsuario.length > 1" class="col-2 pl-1">
              <button (click)="savePedidoTipo()" class="btn btn-primary btn-sm">
                <i class="icofont-ui-edit"></i>
              </button>
            </div> -->
          </div>
        </div>
      </div>
      <!-- <div class="col-3 importa-planilha-itens">
        <div class="mb-3" *ngIf="!loadingUpload">
          <label for="formFile" class="form-label" i18n>Importar planilha de itens</label>
          <br />
          <input class="input-file" type="file" id="formFile" accept=".xls, .xlsx" (change)="onFileSelected($event)" />
        </div>
        <div class="mb-3 loading-circle-container" *ngIf="loadingUpload">
          <div class="loading-circle"></div>
        </div>
      </div> -->
    </div>
    <div *ngIf="!pedidoItens.length" class="row">
      <div class="col-lg-6 offset-lg-3 text-center">
        <img src="assets/empty.png" style="height: 230px" class="img-fluid" />
        <h4 i18n>Selecione alguns produtos!</h4>
      </div>
    </div>
    <div *ngIf="pedidoItens.length">
      <div class="table-responsive">
        <table *ngIf="modo == 1" class="table table-hover table-condensed table-striped table-sm table-responsive-xs">
          <thead class="table-head">
            <tr>
              <th></th>
              <th><label i18n>Produto</label></th>
              <th *ngIf="pedido.tipo.validaEstoque">
                <label i18n>Estoque</label>
              </th>
              <th><label i18n>Quant.</label></th>
              <th class="desconto-col-checkout mostra-desconto"><label i18n>%</label></th>
              <th class="desconto-col-checkout mostra-desconto"><label i18n>Desconto</label></th>
              <th class="unt-preco"><label i18n>R$ Preço unt.</label></th>
              <th><label i18n>R$ Preço</label></th>
              <th></th>
              <th style="width: 20px;">
                <button (click)="expandTable()" [style.background]="'transparent'" [style.border]="'none'">
                  <mat-icon *ngIf="expand">expand_more</mat-icon>
                  <mat-icon *ngIf="!expand">expand_less</mat-icon>
                </button>

              </th>
            </tr>
          </thead>
          <tbody [@expandCollapse]="expand ? 'expanded' : 'collapsed'">
            <tr *ngFor="let item of pedidoItens">
              <td>
                <a *ngIf="item.imagemProduto; else elseBlockImg" href="javascript:void(0);"
                  routerLink="/produto/{{ item.produto }}" i18n-routerLink="/product/{{ item.produto }}"><img
                    src="{{ API_IMAGENS_PRODUTOS }}{{ item.imagemProduto }}" class="img-fluid"
                    style="max-width: 50px" /></a>
                <ng-template #elseBlockImg><img src="assets/no-product-image.jpg" class="img-fluid"
                    style="max-width: 50px" /></ng-template>
              </td>
              <td>
                {{ item.produtoReferencia }} - {{ item.produtoDescricao }}
              </td>
              <td *ngIf="pedido.tipo.validaEstoque">
                <div>
                  <!-- <simple-html
                    [html]="checkErrorEstoque(item.produto)"
                  ></simple-html> -->
                  <i *ngIf="checkErrorEstoque(item); else elseBlockIcn" class="icofont-close"
                    style="color: red; font-size: 25px"></i>
                  <ng-template #elseBlockIcn>
                    <i class="icofont-check" style="color: green; font-size: 28px"></i>
                  </ng-template>
                </div>
              </td>
              <td>{{ item.quantidade }}</td>
              <td i18n class="mostra-desconto">
                <span *ngIf="item.desconto !== null && item.desconto!== undefined">
                  {{item.desconto}} %
                </span>
              </td>
              <td class="mostra-desconto">
                <span *ngIf="item.desconto !== null && item.desconto!== undefined" i18n>
                  R$ {{item.descontoValor | currency : "BRL" : ""}}
                </span>
              </td>
              <td i18n>
                R$
                {{
                this.SITE.mostraImpostoDetalhado
                ? (item.total/item.quantidade | currency : "BRL" : "")
                : ((item.total + item.quantidade * item.imposto)/item.quantidade
                | currency : "BRL" : "")
                }}
              </td>
              <td i18n>
                R$
                {{
                this.SITE.mostraImpostoDetalhado
                ? (item.total | currency : "BRL" : "")
                : (item.total + item.quantidade * item.imposto
                | currency : "BRL" : "")
                }}
              </td>
              <td class="text-center align-middle">
              </td>
              <td class="text-center align-middle">
              </td>
            </tr>
            <tr>

              <td></td>
              <td></td>
              <td *ngIf="pedido.tipo.validaEstoque"></td>
              <td>
                <b>{{ pedidoItensQuantSum }}</b>
              </td>
              <!-- <td class="mostra-desconto">{{this.pedido.descontoPercent === null ? 0 :
                this.pedido.descontoPercent.toFixed(3) }} %</td> -->
              <td class="mostra-desconto">{{this.pedido.descontoPercent === null ? 0 :
                this.percentualDesconto.toFixed(3) }} %</td>
              <!-- <td i18n class="mostra-desconto">R$ {{this.pedido.desconto | currency : "BRL" : ""}} </td> -->
              <td i18n class="mostra-desconto">R$ {{this.totalDesconto| currency : "BRL" : ""}} </td>

              <td></td>
              <td>
                <b i18n>R$ {{ subTotal | currency : "BRL" : "" }}</b>
              </td>
              <td></td>
            </tr>
          </tbody>
          <tbody [@expandCollapse]="expand ? 'collapsed' : 'expanded'">
            <tr>
              <td></td>
              <td></td>
              <td *ngIf="pedido.tipo.validaEstoque"></td>
              <td>
                <b>{{ pedidoItensQuantSum }}</b>
              </td>
              <td>
                <!-- <b>{{
                  valorTotal -
                  retornaNumero(this.form.controls.freteValor.value)
                  | currency : "BRL" : ""
                  }}</b> -->
                <b i18n>R$ {{ subTotal | currency : "BRL" : "" }}</b>
              </td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <table *ngIf="modo === 2" class="table table-hover table-condensed table-striped table-sm table-responsive-xs">
          <thead class="table-head">
            <tr>
              <th></th>
              <th><label i18n>Produto</label></th>
              <th><label i18n>Cor</label></th>
              <th><label i18n>Estampa</label></th>
              <th><label i18n>Tamanho</label></th>
              <th>
                <label *ngIf="this.SITE.mostraEstoqueDigitacao">Estoque</label>
              </th>
              <th><label i18n>Quant.</label></th>
              <th><label i18n>R$ Preço</label></th>
              <th></th>
              <th>
                <button (click)="expandTable()" style="border: 'none'; background: 'transparent'">
                  <mat-icon *ngIf="expand">expand_more</mat-icon>
                  <mat-icon *ngIf="!expand">expand_less</mat-icon>
                </button>
              </th>
            </tr>
          </thead>
          <tbody [@expandCollapse]="expand ? 'expanded' : 'collapsed'">
            <tr *ngFor="let item of pedidoItens">
              <td>
                <a *ngIf="item.nome; else elseBlockImg" href="javascript:void(0);"
                  routerLink="/produto/{{ item.produto }}" i18n-routerLink="/product/{{ item.produto }}"><img
                    src="{{ API_IMAGENS_PRODUTOS }}{{ item.nome }}" class="img-fluid" style="max-width: 50px" /></a>
                <ng-template #elseBlockImg><img src="assets/no-product-image.jpg" class="img-fluid"
                    style="max-width: 50px" /></ng-template>
              </td>
              <td>{{ item.produtoReferencia }} - {{ item.descricao }}</td>
              <td>{{ item.corDescricao }}</td>
              <td>{{ item.estampaDescricao }}</td>

              <td>{{ item.tamanho }}</td>
              <td>
                <div *ngIf="this.SITE.mostraEstoqueDigitacao">
              <td>
                <span *ngIf="checkErrorEstoque(item); else elseBlockEstoque" style="color: red">
                  <b>
                    {{ item.estoque }}
                  </b>
                </span>
                <ng-template #elseBlockEstoque>
                  <span style="color: green">
                    <b>
                      {{ item.estoque }}
                    </b>
                  </span>
                </ng-template>
              </td>
      </div>
      </td>
      <td>{{ item.quantidade }}</td>
      <td i18n>R$ {{ item.total | currency : "BRL" : "" }}</td>
      <td class="text-center align-middle">
        <button routerLink="/produto/{{ item.produto }}" i18n-routerLink="/product/{{ item.produto }}"
          *ngIf="!pedido.salvoCheckout" title="Editar" class="btn btn-outline-primary">
          <i class="icofont-ui-edit"></i>
        </button>
      </td>
      <td class="text-center align-middle">
        <button (click)="confirmDelModo2(item)" data-toggle="modal" data-target="#confirmDelModalModo2"
          title="Excluir" class="btn btn-outline-primary">
          <i class="icofont-trash"></i>
        </button>
      </td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>
          <b>{{ pedidoItensQuantSum }}</b>
        </td>
        <td>
          <b i18n>R$ {{ pedidoItensPrecoSum | currency : "BRL" : "" }}</b>
        </td>
        <td></td>
        <td></td>
      </tr>
      </tbody>
      <tbody [@expandCollapse]="expand ? 'collapsed' : 'expanded'">
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>
            <b>{{ pedidoItensQuantSum }}</b>
          </td>
          <td>
            <b i18n>R$ {{ pedidoItensPrecoSum | currency : "BRL" : "" }}</b>
          </td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
      </table>

    </div>
    <!-- <form *ngIf="!fatalError" (ngSubmit)="onSubmit()" [formGroup]="form"> -->
    <form (ngSubmit)="onSubmit()" [formGroup]="form">
      <div class="col-lg-12">
        <div *ngIf="this.subTotal < this.valorMinimoPedido" class="alert alert-danger" role="alert">
          <span i18n>
            Valor do pedido inferior ao mínimo estipulado de R$
          </span>
          {{
          valorMinimoPedido.toLocaleString(stringLocale)
          }}!
        </div>
        <div *ngIf="error" class="alert alert-danger" role="alert">
          {{ errorMsg }}
        </div>
        <div *ngIf="worningMessage" class="alert alert-primary" role="alert">
          {{ worningMessage }}
        </div>
        <div class="row">
          <!-- <div class="col-lg-4 pl-0">
            <div class="form-group">
              <label i18n>Forma de pagamento</label>
              <select id="formaPagamento" formControlName="formaPagamento" (change)="changeFormaPagamento()"
                class="form-control">
                <option value="">...</option>
                <option *ngFor="let t of formaPagamento" value="{{ t.forma_pagamento_id }}"
                  id="{{ t.forma_pagamento_id }}">
                  {{ t.forma_pagamento }}
                </option>
              </select>
              <div *ngIf="error && form.get('formaPagamento').invalid" class="error" i18n>
                Verifique este campo!
              </div>
            </div>
            <div class="form-group" *ngIf="usaTipoPedido">
              <label i18n>Tipo de pagamento</label>
              <select id="tipoPagamento" formControlName="tipoPagamento" (change)="changeTipoPagamento()"
                class="form-control">
                <option value="">...</option>
                <option *ngFor="let t of tipoPagamento" value="{{ t.id }}">
                  {{ t.descricao }}
                </option>
              </select>
            </div>
            <div *ngIf="uploadFile > 0" class="mb-3 upload-file">
              <label>Arquivo(s)</label><br />
              <ul class="list-group">
                <li class="list-group-item">
                  <label class="btn btn-secondary btn-sm float-right" for="my-file-selector">
                    <input id="my-file-selector" (change)="onSelectedFile($event)" type="file" class="d-none" />
                    <i class="icofont-upload-alt"></i> Selecione
                  </label>
                </li>
                <li *ngFor="let f of files; let i = index" class="list-group-item list-group-item-action">
                  <div (click)="onRemoveFile(i)" class="float-right" style="cursor: pointer; color: #888">
                    XxxxxX
                  </div>
                  {{ f.name }}
                </li>
              </ul>
            </div>
            <div class="form-group num-pedido-cliente">
              <label i18n>Número pedido cliente</label>
              <input type="text" class="form-control" formControlName="numPedidoCliente" />
            </div>
            <div *ngIf="QtdPedidoClienteSelected === 1 && permiteDesconto" class="form-group">
              <label i18n>Desconto(%)</label>
              <div class="row">
                
                <div class="col-10 pl-0">
                  <input 
                    type="number" 
                    class="form-control" 
                    name="descontoPercent" 
                    [(ngModel)]="descontoPercent"
                    (ngModelChange)="onDiscountChange($event)" 
                    min="0" 
                    max="100"
                    (keypress)="onChangeDiscount($event.target.value)" 
                    (change)="onChangeDiscount($event.target.value)" 
                    (blur)="onChangeDiscount($event.target.value)" 
                  />
                </div>
                <div class="col-2">
                  <button type="button" class="btn btn-primary" (click)="applyDiscount()">Aplicar</button>
                </div>
              </div>
            </div>

            <div class="form-group inclui-cupom-checkout">
              <label i18n>Cupom</label>
              <div class="row">
                <div class="col-10 pl-0">
                  <input [(ngModel)]="cupom" type="text" class="form-control" formControlName="cupom"
                    (keypress)="blockSpace($event)" (paste)="sanitizePaste($event)" />
                </div>
                <div *ngIf="idCupom === ''" class="col-2">
                  <button type="button" class="btn btn-primary" (click)="aplicaCupom()">Aplicar</button>
                </div>
                <div *ngIf="idCupom !== ''" class="col-2">
                  <button type="button" class="btn btn-primary" (click)="removeCupom()">Remover</button>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label i18n>Observações</label>
              <textarea formControlName="observacao" name="observacao" rows="8" class="form-control"></textarea>
            </div>
            <div *ngIf="pedido.tipo.obsNotaFiscal" class="form-group">
              <label i18n>Observações Nota Fiscal</label>
              <textarea formControlName="observacaoNota" name="observacaoNota" rows="5" class="form-control"></textarea>
            </div>
          </div> -->
          <!-- <div class="col-lg-4 pl-0">
            <div class="col-lg-12 mt-3 mb-3 pl-0" style="width: 100%">
              <div class="row">
                <div class="col">Subtotal:</div>
                <div class="col">
                  <span i18n>R$ {{ subTotal | currency : "BRL" : "" }}</span>
                </div>
              </div>
              <div *ngIf="acrescimoTotal" class="row mb-1" style="color: red">
                <div class="col" i18n>+ Acréscimos:</div>
                <div class="col">
                  <span i18n>R$ {{ acrescimoTotal | currency : "BRL" : "" }}</span>
                </div>
              </div>
              <div *ngIf="descontoTotal || descontoItens" class="row mb-1" style="color: blue">
                <div class="col" i18n>- Descontos:</div>
                <div class="col">
                  <span i18n>R$ {{ descontoTotal + this.totalDesconto | currency : "BRL" : "" }}</span>
                </div>
              </div>
              <div *ngIf="descontoCupom > 0" class="row mb-1" style="color: blue">
                <div class="col" i18n>- Cupom:</div>
                <div class="col">
                  <span i18n>R$ {{ descontoCupom| currency : "BRL" : "" }}</span>
                </div>
              </div>
              <div *ngIf="SITE.mostraImpostoDetalhado" class="div-checkout-imposto">
                <div *ngIf="impostosTotal" class="row mb-1" style="color: red">
                  <div class="col" style="
                        color: red;
                        margin-right: 115px;
                      " i18n>
                    + Impostos:
                  </div>
                </div>
                <div *ngIf="SITE.mostraImpostoDetalhado">
                  <div *ngFor="let imposto of imposto | keyvalue" class="row" style="color: red">
                    <div class="col" style="color: red; text-align: rigth">
                      <span>{{ imposto.key.replace("_"," ").replace("total","") + ": " }}</span>
                    </div>
                    <div class="col">
                      <span i18n>R$ {{ imposto.value-((imposto.value*descontoPercent)/100) | currency : "BRL" : ""
                        }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="showFreteSum" class="row mb-1" style="color: red">
                <div class="col" i18n>+ Frete:</div>
                <div *ngIf="tipoFrete == 1" class="col">
                  freteValors
                  <span>{{ form.controls.freteValor.value }}</span>
                </div>
                <div *ngIf="tipoFrete == 2" class="col">
                  <span i18n>R$
                    {{
                    form.controls.freteValor.value | currency : "BRL" : ""
                    }}</span>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col">
                  <span style="font-size: 1rem; font-weight: bold" i18n>Valor total:</span>
                </div>
                <div class="col">{{ subTotal + impostosTotal - descontoCupom - descontoTotal + freteValor -
                  totalDesconto-
                  ((impostosTotal*(descontoPercent/100)))| currency :
                  "BRL" : "" }}</span>
                </div>
              </div>
            </div>
            <div *ngIf="clienteIdErp || tipoFrete" class="col-lg-12 mostra-endereco-checkout">
              <table *ngIf="clienteIdErp && !pedido.tipo.permiteDigitacaoCep"
                class="table table-hover table-condensed mb-0" style="margin-left: 0px; width: 400px">

                <tbody *ngIf="selectedCliente.enderecos.length > 0 && filtrados.length === 1">
                  <tr *ngFor="let a of selectedCliente.enderecos">
                    <td style="width: 40px">
                      <input type="radio" [disabled]="pedido.salvoCheckout" (click)="calculaFrete(a.cep)"
                        value="{{ a.idenderecoerp }}" [formControl]="form.controls['idEndereco']" />
                    </td>
                    <td>
                      <h6 i18n>{{ a.endereco }} {{ a.numero }}</h6>
                      {{ a.uf === "0" ? "" : a.uf+" - "}}{{ a.nomecidade }} {{ a.cep === "" || a.cep === null ? "":"("+
                      a.cep.slice(0, 5) + '-' + a.cep.slice(5)+")" }}
                      {{ a.bairro ==="" ? "" : ","+a.bairro}}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div *ngIf="tipoFrete == 1">
                <div class="row">
                  <div class="col-lg-w pl-0">
                    <div class="form-group" style="margin-right: 20px">
                      <label i18n>CEP</label>
                      <input type="text" [formControl]="form.controls['freteCepDestino']" mask="00000-000"
                        class="form-control" />
                      <div *ngIf="error && form.get('freteCepDestino').invalid" class="error" i18n>
                        Verifique este campo!
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-w pr-0" style="margin-left: 20px">
                    <div *ngIf="pedido.tipo.modalidadeFreteCF" class="form-group"
                      style="margin-left: 50px; display: none">
                      <label style="margin-left: 20px" i18n>Modalidade frete</label><br />
                      <label><input type="radio" value="0" formControlName="freteModalidade"
                          (click)="onFreteModalidade('0')" />
                        CIF</label>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <label><input type="radio" value="1" formControlName="freteModalidade"
                          (click)="onFreteModalidade('1')" />
                        FOB</label><br />
                      <div *ngIf="error && form.get('freteModalidade').invalid" class="error" i18n>
                        Verifique este campo!
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-4 pl-0">
                    <div class="form-group">
                      <label i18n>R$ Valor Frete</label>
                      <input type="text" formControlName="freteValor" class="form-control" (blur)="maskMoneyBlur()"
                        (keyup)="maskMoney($event)" />
                      <div *ngIf="error && form.get('freteValor').invalid" class="error" i18n>
                        Verifique este campo!
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="tipoFrete == 2" style="margin-left: 0px; width: 400px">
                <div *ngIf="!freteShow">
                  <label>&nbsp;</label>
                  <div class="alert alert-info" role="alert" i18n>
                    Informe uma forma de pagamento.
                  </div>
                </div>
                <div *ngIf="freteShow">
                  <div class="row">
                    <div class="col-lg-w pl-0">
                      <div class="form-group" *ngIf="pedido.tipo.permiteDigitacaoCep">

                        <label i18n>CEP</label>
                        <div class="input-group">
                          <input type="text" mask="00000-000" [readonly]="!pedido.tipo.permiteDigitacaoCep"
                            [formControl]="form.controls['freteCepDestino']" class="form-control" style="display: ''" />
                          <div class="input-group-append">
                            <button type="button" (click)="
                                  calculaFrete(
                                    this.form.controls.freteCepDestino.value
                                  )
                                " class="btn btn-secondary" style="display: ''" i18n>
                              {{ calculando ? "Calculando..." : "calcular" }}
                            </button>
                          </div>
                        </div>
                        <div *ngIf="error && form.get('freteCepDestino').invalid" class="error" i18n>
                          Verifique este campo!
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 pr-0">
                      <div *ngIf="pedido.tipo.modalidadeFreteCF && false" class="form-group">
                        <label i18n>Modalidade frete</label><br />
                        <label *ngIf="cifPermited"><input type="radio" value="0" formControlName="freteModalidade"
                            [checked]="!fobPermited" (click)="onFreteModalidade('0')" />
                          CIF</label>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <label *ngIf="fobPermited"><input type="radio" value="1" formControlName="freteModalidade"
                            [checked]="!cifPermited" (click)="onFreteModalidade('1')" />
                          FOB</label><br />
                        <div *ngIf="error && form.get('freteModalidade').invalid" class="error" i18n>
                          Verifique este campo!
                        </div>
                      </div>
                    </div>
                  </div>
                  <label i18n *ngIf="fretes.retirar.length > 0">Entrega</label>
                  <br />
                  <button type="button" *ngIf="fretes.retirar.length > 0" id="calc" (click)="switchReceber()"
                    class="btn btn-secondary" style="width: 41%; margin-right: 10px"
                    [style.backgroundColor]="!retirar ? '#1c5c46' : '#868e96'" i18n>
                    Receber
                  </button>
                  <button type="button" id="btn-retirar" (click)="mostrarTabela()" *ngIf="fretes.retirar.length > 0"
                    class="btn btn-secondary" style="width: 41%"
                    [style.backgroundColor]="retirar ? '#1c5c46' : '#868e96'" i18n>
                    Retirar
                  </button>
                  <div class="form-group">
                    <div class="btn-group btn-group-toggle" data-toggle="buttons" style="width: 100%">
                      <div *ngIf="!freteSalvoDescr" class="float-right" style="color: #888"></div>

                      <br />
                      <div class="form-group" id="divfrete" style="
                            cursor: pointer;
                            display: none;
                            margin-top: 1rem;
                            width: 100%;
                          ">
                        <label for="freteId"> Frete </label>
                        <div _ngcontent-rdo-c11="" class="float-right ng-star-inserted" style="color: #888">
                          <small _ngcontent-rdo-c11="">Selecione uma opção</small>
                        </div>
                        <ul id="receber" style="padding: 0">
                          <li style="padding: 0.5rem 0.75rem" *ngFor="let f of fretes.receber"
                            class="list-group-item list-group-item-action" (click)="onFrete(f.id)">
                            <div *ngIf="f.error; else elseBlockFrete">
                              <span style="padding: 30px">{{
                                f.message | json
                                }}</span><br />
                              <span style="padding: 30px">{{ f.label }}</span>
                            </div>
                            <ng-template #elseBlockFrete>
                              <input style="display: none !important; width: 25px" type="radio" value="{{ f.id }}"
                                formControlName="freteId" />
                              <div class="d-flex row">
                                <div class="col-1">
                                  <div class="mt-1 {{
                                        form.controls.freteId.value == f.id
                                          ? 'selected-radio'
                                          : 'unselected-radio'
                                      }}">
                                    <div *ngIf="
                                          form.controls.freteId.value == f.id
                                        " class="selected-radio-inside"></div>
                                  </div>
                                </div>
                                <div class="col">
                                  <span *ngIf="f.valor; else elseBlockFreteValor">
                                    <span i18n>
                                      {{
                                      f.valor === null ? " " :
                                      f.valor === 0
                                      ? "Grátis"
                                      : "R$" + f.valor
                                      }}
                                      - {{ f.label }} - {{ f.labelPrazo }}
                                    </span>
                                  </span>
                                  <ng-template #elseBlockFreteValor>
                                    <span>
                                      {{ f.label }}
                                      <span class="frete-gratis" i18n *ngIf="f.valor !== null">
                                        -
                                        {{

                                        f.valor === 0
                                        ? "Grátis"
                                        : "R$" + f.valor
                                        }}
                                      </span>
                                      <div class="float-right" style="color: #888; font-size: 0.8rem">
                                        {{ f.labelPrazo }}
                                      </div>
                                    </span>
                                  </ng-template>
                                </div>
                              </div>
                            </ng-template>
                          </li>
                        </ul>

                        <ul id="retirar" style="padding: 0">
                          <li style="padding: 0.5rem 0.75rem" *ngFor="let f of fretes.retirar"
                            class="list-group-item list-group-item-action" (click)="onFreteRetirar(f.id)">
                            <div *ngIf="f.error; else elseBlockFrete">
                              <span style="padding: 30px">{{
                                f.message | json
                                }}</span><br />
                              <span style="padding: 30px">{{ f.label }}</span>
                            </div>
                            <ng-template #elseBlockFrete>
                              <input style="display: none !important; width: 25px" type="radio" value="{{ f.id }}"
                                formControlName="freteId" />
                              <div class="d-flex row">
                                <div class="col-1">
                                  <div class="mt-1 {{
                                        form.controls.freteId.value == f.id
                                          ? 'selected-radio'
                                          : 'unselected-radio'
                                      }}">
                                    <div *ngIf="
                                          form.controls.freteId.value == f.id
                                        " class="selected-radio-inside"></div>
                                  </div>
                                </div>
                                <div class="col">
                                  <span *ngIf="f.valor; else elseBlockFreteValor">
                                    <span i18n>
                                      {{
                                      f.valor === 0
                                      ? "Grátis"
                                      : "R$" + f.valor
                                      }}
                                      - {{ f.label }} - {{ f.prazo }} dias
                                      úteis
                                    </span>
                                  </span>
                                  <ng-template #elseBlockFreteValor>
                                    <span>{{ f.label }}</span>
                                  </ng-template>
                                </div>
                              </div>
                            </ng-template>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div class="col-lg-4 pl-0">
            <app-credit-card  class="align-right" [pedido]="this.pedidoService.pedido.id" [total]="valorTotal"
              [currentFormaPagamento]="this.currentFormaPagamento" [onSubmit]="onSubmit"></app-credit-card>
            <div class="col-lg-12 mt-3 mb-3 pl-0" style="width: 100%">
              <div *ngIf="pedido.clientes.length > 1" class="col-sm-12">
              </div>
             
              <button class="btn btn-primary btn-lg float-right" style="font-size: 1.2rem !important" *ngIf="
                    isPix() &&
                    !SITE.gera_pagamento_aprovacao &&
                    form.controls.freteId.errors === null
                  ">

                <i class="icofont-check-circled"></i>
                Gerar Link de Pagamento
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<input type="text" id="inputLinkAprovaCliente" style="opacity: 0" />
</div>
<div class="modal fade" id="confirmDelModalModo2" tabindex="-1" role="dialog" aria-labelledby="confirmDelModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>Confirma exclusão?</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-footer">
        <button (click)="removeItemModo2()" type="button" data-dismiss="modal" class="btn btn-outline-primary">
          Ok
        </button>
        <button type="button" data-dismiss="modal" class="btn btn-primary" i18n>
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="confirmDelModal" tabindex="-1" role="dialog" aria-labelledby="confirmDelModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>Deseja realmente excluir?</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-footer">
        <button (click)="removeItem()" type="button" data-dismiss="modal" class="btn btn-outline-primary">
          Ok
        </button>
        <button type="button" data-dismiss="modal" class="btn btn-primary" i18n>
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="pixModal" tabindex="-1" role="dialog" aria-labelledby="pixModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>QR code de pagamento</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="redirect()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body col mx-auto text-center">
        <img width="200" height="200" [src]="getSafeImageUrl()" />
        <span class="copy-btn" (click)="copyLink(qrCode.codigo_qrcode)">
          {{ qrCode.codigo_qrcode }}
        </span>

        <br />
        <button class="btn btn-success mt-2" (click)="copyLink(qrCode.codigo_qrcode)">
          Copiar código
        </button>
      </div>
      <!-- <div class="modal-footer">
        <button
          (click)="removeItem()"
          type="button"
          data-dismiss="modal"
          class="btn btn-outline-primary"
        >
          Ok
        </button>
        <button type="button" data-dismiss="modal" class="btn btn-primary" i18n>
          Cancelar
        </button>
      </div> -->
    </div>
  </div>
</div>